/*
function applyScript() {
setTimeout(function(){
// Get all elements with class ".bold_option_value"
var optionElements = document.querySelectorAll('.bold_option_value');
console.log("BOLD==>")
// Loop through each option element
optionElements.forEach(function(optionElement) {
// Check if the option has a swatch
var swatchElement = optionElement.querySelector('.bold_option_value_swatch span');
if (swatchElement) {

  // Check if the option already has a "hover_image" span
  var existingHoverImage = optionElement.querySelector('.hover_image');
  if (existingHoverImage) {
  // Remove the existing "hover_image" span
  existingHoverImage.remove();
  }
  // Create a new span element with class "hover_image"
  var new_bold_title = document.createElement('span');
  new_bold_title.classList.add('new_bold_title');
  var oldTitle = optionElement.querySelector(".bold_option_value_title").textContent;
  new_bold_title.prepend(oldTitle);
  // Append the "hover_image" span to the "bold_option_swatch_title" element
  var swatchTitleElement = optionElement.querySelector('.bold_option_value label');
  swatchTitleElement.append(new_bold_title);
}
});
},500)
}


function observeDOM() {
  var observer = new MutationObserver(function(mutationsList) {
    for (var mutation of mutationsList) {
      if (mutation.type === 'childList' && mutation.target.classList.contains('bold_options_loaded')) {
        applyScript();
        document.querySelectorAll(".bold_option_element input, .bold_option_element select").forEach(function(element) {
          element.addEventListener('change', function() {
          applyScript();
          
          })
        })
        observer.disconnect();
        break;
      }
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

document.addEventListener('DOMContentLoaded', function() {
  observeDOM();
});
*/

// added by Shop Circle (Armin)
document.addEventListener('DOMContentLoaded', function() {
  BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_products_loaded', function(event) {
    var optionsDiv = document.querySelector('.bold_options_loaded');
    if (optionsDiv && optionsDiv.children.length !== 0) {
      buttonRedirect();
      openForm();
      boldPopupInit();
      snapFileUploadToRadio();
      hidePrintingDetailsTitle();
    }
  });
});

/*
function openForm() {
  var hulkForm = document.querySelector('.hulk_form_overlay');
  var allCheckboxes = document.querySelectorAll('.bold_option_checkbox');
  allCheckboxes.forEach((checkbox) => {
    var title = checkbox.querySelector('.bold_option_title');
    if (title.innerText === '*WANT MORE CUSTOMIZATION?') {
      title.parentElement.querySelector('input[type="checkbox"]').onchange = () => {
        hulkForm.classList.toggle('visible');
      };
    }
    document.querySelector('.closeHulkForm').onclick = () => {
      hulkForm.classList.remove('visible');
    }
  })
}
*/
function addCloseButton() {
  if (!(document.querySelector('.closeBoldPopup'))) {
    var closeBoldPopup = document.createElement('div');
    closeBoldPopup.className = 'closeBoldPopup';
    var seeDetailsText = document.querySelector('.bold_option_displaytext.bold_popup p span');
    
    if (seeDetailsText) {
      seeDetailsText.appendChild(closeBoldPopup);
      
      // --- UPDATED CLICK EVENT BELOW ---
      closeBoldPopup.addEventListener('click', function(){
        var targetOption = document.querySelector('input[name*="See Details"]');
        if (targetOption) {
          targetOption.click();
        } else {
          console.error('Could not find the See Details checkbox to close the modal.');
        }
      });
      
    } else {
      console.error('Target element not found');
    }
  }
}

function boldPopupInit() {
  var boldDisplayText = document.querySelector('.bold_option_displaytext');
  if (boldDisplayText) {
    setTimeout(() => {
      var boldPopup = document.querySelector('.bold_option_displaytext.bold_option_hidden');
      console.log(boldPopup);
      boldPopup.classList.add('bold_popup');
      classObserver.observe(document.querySelector('.bold_option_displaytext.bold_option_hidden'), {
          attributes: true,
          attributeFilter: ['class']
      });
    }, 500);
  }
}

var classObserver = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    if (!(mutation.target.classList.contains('bold_option_hidden'))) {
      addCloseButton();
    }
  });
});
// added by Shop Circle (Armin)



// added by Shop Circle (Joseph)
function openForm() {
  var hulkForm = document.querySelector('.hulk_form_overlay');
  var allCheckboxes = document.querySelectorAll('.bold_option_radio');
  allCheckboxes.forEach((checkbox) => {
    var title = checkbox.querySelector('.bold_option_value_title');
    if (title.innerText === 'Start Inquiry') {
      title.parentElement.querySelector('input[type="radio"]').onclick = () => {
        hulkForm.classList.toggle('visible');
      };
    }
    document.querySelector('.closeHulkForm').onclick = () => {
      hulkForm.classList.remove('visible');
    }
  })
}
//added by Shop Circle (Joseph)


function snapFileUploadToRadio() {
  var uploadContainer = document.querySelector('.bold_option_uploadfile');
  
  // Updated with the exact working text string
  var targetRadio = document.querySelector('input[value="Create new plate (+$100 one-time fee)"]');
  
  if (uploadContainer && targetRadio) {
    var targetLabel = targetRadio.closest('label');
    if (targetLabel) {
      targetLabel.appendChild(uploadContainer);
    }
  }
}

function hidePrintingDetailsTitle() {
  // Find all option titles on the page
  var allTitles = document.querySelectorAll('.bold_option_title');
  
  // Loop through them to find the exact match
  allTitles.forEach(function(title) {
    if (title.innerText.trim() === '*PRINTING DETAILS') {
      title.style.display = 'none'; // Hides just this specific span
    }
  });
}

function openForm() {
  var hulkForm = document.querySelector('.hulk_form_overlay');
  
  // 1. Target the exact input by its name attribute (100% reliable)
  var triggerInput = document.querySelector('input[name="properties[SPECIAL CUSTOMIZATION INQUIRY]"]');
  
  if (triggerInput && hulkForm) {
    // 2. Find the label wrapping it (this is your ghost button)
    var labelBtn = triggerInput.closest('label');
    
    if (labelBtn) {
      // 3. Attach the click event
      labelBtn.onclick = function() {
        hulkForm.classList.add('visible');
        
        // 4. Move the X button with a tiny delay to outsmart the app loading times
        setTimeout(function() {
          var closeBtn = document.querySelector('.closeHulkForm');
          var formContainer = document.querySelector('.pxFormGenerator');
          
          if (closeBtn && formContainer && closeBtn.parentElement !== formContainer) {
            formContainer.appendChild(closeBtn);
          }
        }, 150); // 150 milliseconds is unnoticeable to the user but safe for the DOM
      };
    }
  }

  // 5. Ensure the close button works even after being moved
  // We use event delegation here on the overlay itself
  if (hulkForm) {
    hulkForm.onclick = function(e) {
      if (e.target.closest('.closeHulkForm')) {
        hulkForm.classList.remove('visible');
      }
    };
  }
}